// @core/api/endpoints/billing/post_journal_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PostJournalEntryRequest,
  PostJournalEntryResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Post journal entry to ledger
 * Posts a balanced journal entry to the general ledger, creating permanent ledger entries and updating account balances. Posted entries cannot be modified.
 */
export async function PostJournalEntry(
  id: string,
  data: PostJournalEntryRequest,
  options?: RequestOptions
): Promise<PostJournalEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/journal-entries/:id/post`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<PostJournalEntryResponse>(requestPath, data, requestOptions);
}
